import React, { useCallback } from 'react';
import { Box, Chip } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import { CONTRACT_TYPE_OPTIONS } from '../../../utils/contractType';

// "계약 관리" 유형 칩(전체/프로젝트/유지보수) - 같은 화면의 ProjectStatusList와
// chancemng/info/ChanceStatusList.js(포캐스팅 목록)와 같은 칩 스타일/라벨을 쓴다.
const ContractTypeList = ({ value, onChange }) => {
  const handleClick = useCallback(
    (nextValue) => {
      if (nextValue === value) return;
      onChange?.(nextValue);
    },
    [value, onChange],
  );

  return (
    <Box
      className="contract-type-chip-list"
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 0.75,
        justifyContent: 'flex-end',
        alignItems: 'center',
        m: 1,
      }}
    >
      {CONTRACT_TYPE_OPTIONS.map((opt) => (
        <Chip
          key={opt.value || 'all'}
          icon={<CircleIcon />}
          label={opt.label}
          variant={opt.value === value ? 'contained' : 'outlined'}
          color={opt.color}
          onClick={() => handleClick(opt.value)}
        />
      ))}
    </Box>
  );
};

export default ContractTypeList;
